import validate from "/usr/src/app/content/n3-promos-4d4bab99-25f6-4b60-90be-b880dda68538/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-4d4bab99-25f6-4b60-90be-b880dda68538/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}